import styled from "styled-components";
import { applyGradient } from "./blue-gradient-background";

export const GradientBorder = styled.div`
  height: 1px;
  ${applyGradient()}
`;
